"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSliderStyles = exports.getSliderHandleContainerStyles = exports.getSliderHandleStyles = exports.getSliderTickBarStyles = exports.getSliderTrackStyles = void 0;
var tslib_1 = require("tslib");
var Icons_1 = require("../../icons/Icons");
var FocusIndicators_1 = require("../../styles/FocusIndicators");
var TabStyles_1 = require("../../styles/TabStyles");
var sliderHandleIconHalfSize = { w: Math.ceil(Icons_1.SliderHandleIcon.width / 2), h: Math.ceil(Icons_1.SliderHandleIcon.height / 2) };
var sliderHeight = 40;
// It's just a coincidence that the following two constants are equal
var sliderTickHeight = 4;
var sliderTrackHeight = 4;
var sliderHandleSize = { w: 40, h: 40 };
var sliderHandleHalfSize = { w: sliderHandleSize.w / 2, h: sliderHandleSize.h / 2 };
var sliderHandlePressIndicationBarHeight = 16;
var sliderSpaceBetweenTickBarAndTrack = 11;
var sliderLeftRightPadding = 14;
exports.getSliderTrackStyles = function () {
    var basicStyles = {
        Track: {
            position: 'absolute',
            left: sliderHandleIconHalfSize.w,
            right: sliderHandleIconHalfSize.w,
            backgroundColor: TabStyles_1.TabStyles.Colors.L3,
            height: sliderTrackHeight,
            top: (sliderHeight - sliderTrackHeight) / 2,
        },
        RangeIndicatorBar: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            backgroundColor: TabStyles_1.TabStyles.Colors.L7,
        },
        DataBar: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            backgroundColor: TabStyles_1.TabStyles.Colors.L8,
        }
    };
    return tslib_1.__assign(tslib_1.__assign({}, basicStyles), { RangeIndicatorBarDarkened: tslib_1.__assign(tslib_1.__assign({}, basicStyles.RangeIndicatorBar), { backgroundColor: TabStyles_1.TabStyles.Colors.L8 }), RangeIndicatorBarFocused: tslib_1.__assign(tslib_1.__assign({}, basicStyles.RangeIndicatorBar), { backgroundColor: TabStyles_1.TabStyles.Colors.Focus, boxShadow: FocusIndicators_1.DefaultFocusIndicator.boxShadow }), DataBarDarkened: tslib_1.__assign(tslib_1.__assign({}, basicStyles.DataBar), { backgroundColor: TabStyles_1.TabStyles.Colors.L9 }), DataBarFocused: tslib_1.__assign(tslib_1.__assign({}, basicStyles.DataBar), { backgroundColor: "rgb(24, 71, 102)", boxShadow: FocusIndicators_1.DefaultFocusIndicator.boxShadow }) });
};
exports.getSliderTickBarStyles = function () {
    return {
        Bar: {
            position: 'absolute',
            left: sliderHandleIconHalfSize.w,
            // The + 1 here is to make the spread of the ticks match the width of the track bar (above).  Since we position
            // the ticks using `left: X%`, the far right tick is actually 1px into the `right` space.  The + 1
            // counterintuitivly shrinks the width of the tick bar so that the final tick is now directly above the right end
            // of the slider track.
            right: sliderHandleIconHalfSize.w + 1,
            height: sliderTickHeight,
            top: (sliderHeight - sliderTrackHeight) / 2 - sliderSpaceBetweenTickBarAndTrack - sliderTickHeight,
        },
        Tick: {
            position: 'absolute',
            borderLeft: "solid 1px " + TabStyles_1.TabStyles.Colors.L6,
            height: sliderTickHeight,
            width: 0,
        }
    };
};
exports.getSliderHandleStyles = function () {
    var basicStyles = {
        PositioningContainer: {
            position: 'absolute',
        },
        PressIndicationBar: {
            position: 'absolute',
            borderLeft: "solid 2px " + TabStyles_1.TabStyles.Colors.L9,
            // If we dont push it to the left by 1 px the looks off center from the circle icon
            marginLeft: -1,
            width: 0,
            height: sliderHandlePressIndicationBarHeight,
            top: -3,
        },
        HandleInteractiveArea: {
            position: 'absolute',
            touchAction: 'none',
            width: Icons_1.SliderHandleIcon.width,
            height: Icons_1.SliderHandleIcon.height,
            boxSizing: 'content-box',
            paddingTop: sliderHandleHalfSize.h - sliderHandleIconHalfSize.h,
            paddingBottom: sliderHandleHalfSize.h - sliderHandleIconHalfSize.h,
            paddingLeft: sliderHandleHalfSize.w - sliderHandleIconHalfSize.w,
            paddingRight: sliderHandleHalfSize.w - sliderHandleIconHalfSize.w,
            marginLeft: -1 * sliderHandleHalfSize.w,
            WebkitTouchCallout: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none',
        },
        HandleIcon: {
            position: 'absolute',
            touchAction: 'none',
            cursor: 'pointer',
            width: Icons_1.SliderHandleIcon.width,
            height: Icons_1.SliderHandleIcon.height,
            marginLeft: -1 * (sliderHandleIconHalfSize.w),
            marginTop: (sliderHandleHalfSize.h - sliderHandleIconHalfSize.h),
            outline: 'none',
            WebkitTouchCallout: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
        }
    };
    return tslib_1.__assign(tslib_1.__assign({}, basicStyles), { HandleInteractiveAreaLeft: tslib_1.__assign(tslib_1.__assign({}, basicStyles.HandleInteractiveArea), { paddingLeft: basicStyles.HandleInteractiveArea.paddingLeft - 5, paddingRight: basicStyles.HandleInteractiveArea.paddingRight + 5 }), HandleInteractiveAreaRight: tslib_1.__assign(tslib_1.__assign({}, basicStyles.HandleInteractiveArea), { paddingLeft: basicStyles.HandleInteractiveArea.paddingLeft + 6, paddingRight: basicStyles.HandleInteractiveArea.paddingRight - 4 }), HandleIconLeft: tslib_1.__assign(tslib_1.__assign({}, basicStyles.HandleIcon), { marginLeft: basicStyles.HandleIcon.marginLeft - 5 }), HandleIconRight: tslib_1.__assign(tslib_1.__assign({}, basicStyles.HandleIcon), { marginLeft: basicStyles.HandleIcon.marginLeft + 6 }), DisabledHandleMixin: {
            touchAction: undefined,
        }, DisabledHandleInnerFocusAreaMixin: {
            touchAction: undefined,
            cursor: undefined,
        } });
};
exports.getSliderHandleContainerStyles = function () {
    return {
        Container: {
            position: 'absolute',
            top: 0, bottom: 0, left: 0, right: 0,
            // We restrict the horizontal space (that the handle can be positioned in) a bit and take away half the width of
            // the handle icon on the left and right sides.  This way, because we center the handle at a given position, if
            // the handle is at the far left it isn't half outside the bounds of the slider.  Same thing if it is at the far
            // right.
            //
            // Also the + 1 here is to:
            // A. Make the handle area occupy the same amount of horizontal space as the tick bar (which is one pixel smaller
            // than the track, see above)
            // B. accommodate the press indicator bar being moved to the left 1px (so it will line up w/ the ticks)
            marginLeft: sliderHandleIconHalfSize.w + 1,
            marginRight: sliderHandleIconHalfSize.w,
        },
        RangeHandleArea: {
            position: 'absolute',
            cursor: 'pointer',
            height: Icons_1.SliderHandleIcon.height,
            outline: 'none',
            top: sliderHandleHalfSize.h - sliderHandleIconHalfSize.h,
        }
    };
};
exports.getSliderStyles = function () {
    return {
        OuterContainer: {
            paddingLeft: sliderLeftRightPadding,
            paddingRight: sliderLeftRightPadding,
            WebkitTapHighlightColor: 'transparent',
            TapHighlightColor: 'transparent',
        },
        TrackAndHandleContainer: {
            position: 'relative',
            height: sliderHeight,
        },
    };
};
//# sourceMappingURL=SliderStyles.js.map